import { DashboardFilters } from "@/dashboard/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDashboardRankingsGroups } from "../../hooks/use-dashboard-rankings-groups";
import { RankingsDataTable, type RankingsRow } from "../rankings-data-table";

interface DashboardRankingsGroupsDataTableProps {
  filters: DashboardFilters;
}

export const DashboardRankingsGroupsDataTable = ({
  filters,
}: DashboardRankingsGroupsDataTableProps) => {
  const [t] = useTranslation(["dashboard"]);
  const { isLoading, top3RankingData, otherRankingData } =
    useDashboardRankingsGroups(filters);

  // O pódio (top 3) deixou de ser cards separados: o Figma mostra o ranking
  // inteiro numa tabela só, na ordem da API.
  const rows = useMemo<RankingsRow[]>(
    () => [...top3RankingData, ...otherRankingData],
    [top3RankingData, otherRankingData],
  );

  return (
    <RankingsDataTable
      data-testid="dashboard-rankings-groups-table"
      rows={rows}
      isLoading={isLoading}
      nameHeader={t("dashboard-rankings-groups-table-header-name") as string}
      valueHeader={t("dashboard-rankings-groups-table-header-value") as string}
    />
  );
};
